import { AddContextualData } from '@opendoor/observability';
import { ShowingRequestCreation } from 'buying/routes/ShowingRequestCreation';

export default function ShowingRequestCreationRoute(): RouteComponentOutput {
  return (
    <AddContextualData data={{ topLevelRoute: 'buyer-tour' }}>
      <ShowingRequestCreation />
    </AddContextualData>
  );
}
